const VisitorPassTypes = {
	/** ****************************** CREATE VISITOR PASS *********************** */
	CREATE_VISITOR_PASS_START: 'create_visitor_pass_start',
	CREATE_VISITOR_PASS_SUCCESS: 'create_visitor_pass_success',
	CREATE_VISITOR_PASS_FAILURE: 'create_visitor_pass_failure',
	CREATE_VISITOR_PASS_RESPONSE_REST_START: 'create_visitor_pass_response_rest_start',
	
	/** ****************************** GET ALL VISITOR PASSES *********************** */
	GET_ALL_VISITOR_PASSES_START: 'get_all_visitor_passes_start',
	GET_ALL_VISITOR_PASSES_SUCCESS: 'get_all_visitor_passes_success',
	GET_ALL_VISITOR_PASSES_FAILURE: 'get_all_visitor_passes_failure',
	GET_ALL_VISITOR_PASSES_RESPONSE_REST_START: 'get_all_visitor_passes_response_rest_start',
	
	/** ****************************** GET VISITOR PASS *********************** */
	GET_VISITOR_PASS_START: 'get_visitor_pass_start',
	GET_VISITOR_PASS_SUCCESS: 'get_visitor_pass_success',
	GET_VISITOR_PASS_FAILURE: 'get_visitor_pass_failure',
	GET_VISITOR_PASS_RESPONSE_REST_START: 'get_visitor_pass_response_rest_start',
	
	/** ****************************** UPDATE VISITOR PASS *********************** */
	UPDATE_VISITOR_PASS_START: 'update_visitor_pass_start',
	UPDATE_VISITOR_PASS_SUCCESS: 'update_visitor_pass_success',
	UPDATE_VISITOR_PASS_FAILURE: 'update_visitor_pass_failure',
	UPDATE_VISITOR_PASS_RESPONSE_REST_START: 'update_visitor_pass_response_rest_start',
	
	/** ****************************** DELETE VISITOR PASS *********************** */
	DELETE_VISITOR_PASS_START: 'delete_visitor_pass_start',
	DELETE_VISITOR_PASS_SUCCESS: 'delete_visitor_pass_success',
	DELETE_VISITOR_PASS_FAILURE: 'delete_visitor_pass_failure',
	DELETE_VISITOR_PASS_RESPONSE_REST_START: 'delete_visitor_pass_response_rest_start',
};

export default VisitorPassTypes; 